<script>

    import OperativePlanService from '../../services/operative-plan';
    import EquipmentOperationService from '../../services/equipment-operation';
    import Utils from '../../common/Utils';
    import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'
    export default{
        components: {
            ResponsiveButton
        },
        data(){
            return {
                lots: [],
                equipmentOperations: [],
                selectedLots: {},
                
                selectedEquipmentOperations: {},
                results: [],
                lotsLoading: false,
                equipmentOperationsLoading: false,
                resultsLoading: false,
                inputDataCollapsed: false,
                resultsDataCollapsed: true,
                
                previewData: {},
                splitTypes: [ 'PARTIAL','FINAL' ],
                selectedLotsSplitType: 'FINAL'
            }
        },
        created(){
            this.loadLots();
            this.loadEquipmentOperations();
        },
        mounted() {
            this.$store.dispatch('security/setNavbarTitle', 'fixedBalanceDistribution.page_title');
        },
        methods: {
            loadLots(){
                this.lotsLoading = true;
                OperativePlanService.getFixedBalanceSplitLots(this.$route.query.idScheduledOperation, (response) => {
                    this.lotsLoading = false;
                    if(response.success){
                        this.lots = response.data;
                    }
                });
            },
            loadEquipmentOperations(){
                this.equipmentOperationsLoading = true;
                EquipmentOperationService.getMeasureListByIdScheduledOperation(this.$route.query.idScheduledOperation, (response) => {
                    this.equipmentOperationsLoading = false;
                    if(response.success){
                        this.equipmentOperations = response.data;
                    }
                });
            },
            calculateMovedQtyTotal(field, value, items){
                let sum = 0;
                items.forEach(op => {
                    if(op[field] == value){
                        sum += op.movedWeight;
                    }
                })
                return sum;
                //return Utils.formatDecimal(sum.toLocaleString(), 3);
            },
            calculateMovedVolumeTotal(field, value, items){
                let sum = 0;
                items.forEach(op => {
                    if(op[field] == value){
                        sum += op.movedVolume;
                    }
                })
                return sum;
                //return Utils.formatDecimal(sum.toLocaleString(), 3);
            },
            calculate(){
                let destinationScheduledIdList = [];//this.selectedLots.map(el => el.idScheduledOperation);
                for(let key in this.selectedLots){
                    if(this.selectedLots[key]){
                        destinationScheduledIdList.push(key)
                    }
                }
                let selectedEquipmentOperationMeasuresIdList = []; //this.selectedEquipmentOperations.map(el => el.id);
                for(let key in this.selectedEquipmentOperations){
                    if(this.selectedEquipmentOperations[key]){
                        selectedEquipmentOperationMeasuresIdList.push(key)
                    }
                }

                this.previewData = {
                    mainOperationScheduledId: this.$route.query.idScheduledOperation,
                    destinationScheduledIdList: destinationScheduledIdList,
                    selectedEquipmentOperationMeasuresIdList: selectedEquipmentOperationMeasuresIdList,
                    persistData: false,
                    splitType: this.selectedLotsSplitType
                };
                this.results = [];
                this.resultsDataCollapsed = true;
                EquipmentOperationService.fixedBalanceSplit(this.previewData, (response) => {
                    this.resultsDataCollapsed = false;
                    if(response.success){
                        this.results = response.data;
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                })
            },
            saveSplitResults(){
                let body = {...this.previewData};
                body.persistData = true;
                this.$store.dispatch("generic/setLoading", true);
                EquipmentOperationService.fixedBalanceSplit(body, (response) => {
                    this.$store.dispatch("generic/setLoading", false);
                    if(response.success){
                        this.$toast.add({detail: this.$t('fixedBalanceDistribution.saveSuccess'), life:3000, severity: 'success'});

                        this.previewData = {};
                        this.results = [];
                        this.loadLots();
                        this.loadEquipmentOperations();
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                })
            }
        },
        computed: {
            utils(){
                return Utils;
            },
        }
    };
</script>


<template>
  <main>
    <div class="grid">
        <div class="col-12">
            <Panel :header="$t('fixedBalanceDistribution.lotsToShare')" :toggleable="true" v-model:collapsed="inputDataCollapsed">
                <DataTable
                    :loading="lotsLoading"
                    :scrollable="true" scrollHeight="flex"
                    responsiveLayout="scroll" class="p-datatable-sm"
                    :reorderableColumns="true" ref="lots" :value="lots">
                    <Column style="width: 40px">
                        <template #body="element">
                            <Checkbox v-model="selectedLots[element.data.idScheduledOperation]" :binary="true" v-if="element.data.idScheduledOperation != $route.query.idScheduledOperation"/>
                        </template>
                    </Column>
                    <Column style="width: 160px" field="lotCode" :header="$t('fiscalNotification.equipmentCode')" />
                    <Column style="width: 160px" field="fiscalNotificationCode" :header="$t('fiscalNotification.notificationCode')" />
                    <Column style="width: 160px" field="registryProduct" :header="$t('product.fk')" />
                    <Column style="width: 160px" field="tanksList" :header="$t('operativePlan.tankListString')" />
                    <Column style="width: 160px" field="isFixedLot" :header="$t('movementInstructions.typeMovementInstructionLotCode')">
                        <template #body="element">
                            {{element.data.isFixedLot ? 'F': 'B'}}
                        </template>
                    </Column>
                    <Column style="width: 160px" field="qty" :header="$t('operativePlan.quantity')" />
                    <Column style="width: 160px" field="qtyMin" :header="$t('operativePlan.minimumQuantity')" />
                    <Column style="width: 160px" field="qtyMax" :header="$t('operativePlan.maximumQuantity')" />
                    <template #empty>
                        {{$t('noRecordsFound')}}
                    </template>
                </DataTable>
            </Panel>
        </div>
        <div class="col-12">
            <Panel :header="$t('fixedBalanceDistribution.lotsMeasures')" :toggleable="true" v-model:collapsed="inputDataCollapsed">
                <DataTable
                    groupRowsBy="idOperativePlan" rowGroupMode="subheader"
                    :loading="equipmentOperationsLoading"
                    :scrollable="true" scrollHeight="flex"
                    responsiveLayout="scroll" class="p-datatable-sm"
                    :reorderableColumns="true" ref="equipmentOperations" :value="equipmentOperations">
                    <Column style="width: 40px">
                        <template #body="element">
                            <Checkbox v-model="selectedEquipmentOperations[element.data.id]" :binary="true" v-if="element.data.idMainScheduledOperationFixedBalanceSplit == null"/>
                        </template>
                    </Column>
                    <Column style="width: 160px" field="tankCode" :header="$t('tankOperations.tank')" />
                    <Column style="width: 160px" field="operationDate" :header="$t('tankOperations.operationDate')">
                        <template #body="element">
                            {{element.data.operationDate != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(element.data.operationDate)) : null}}
                        </template>
                    </Column>
                    <Column style="width: 160px" field="fiscalCommunicationCode" :header="$t('fiscalNotification.notificationCode')" />
                    <Column style="width: 160px" field="productLevel" :header="$t('fixedBalanceDistribution.level')">
                        <template #body="element">
                            <span>{{utils.formatInteger(element.data.productLevel)}}</span>
                        </template>
                    </Column>
                    <Column style="width: 160px" field="temperature" :header="$t('fixedBalanceDistribution.temperature')" >
                        <template #body="element">
                            <span>{{utils.formatDecimal(element.data.temperature,2)}}</span>
                        </template>
                    </Column>
                    <Column style="width: 160px" field="density15" :header="$t('fixedBalanceDistribution.density')" >
                        <template #body="element">
                            <span>{{utils.formatDecimal(element.data.density15,5)}}</span>
                        </template>
                    </Column>
                    <Column style="width: 160px" field="waterLevel" :header="$t('fixedBalanceDistribution.waterLevel')" >
                        <template #body="element">
                            <span>{{utils.formatInteger(element.data.waterLevel)}}</span>
                        </template>
                    </Column>
                    <Column field="movedWeight" :header="$t('fixedBalanceDistribution.movedQty')" bodyClass="rightColumnContent">
                        <template #body="element">
                            <span>{{utils.formatInteger(element.data.movedWeight)}}</span>
                        </template>
                    </Column>
                    <Column style="width: 160px" field="stockWeight" :header="$t('fixedBalanceDistribution.stockQty')" >
                        <template #body="element">
                            <span>{{utils.formatInteger(element.data.stockWeight)}}</span>
                        </template>
                    </Column>
                    <Column  field="movedVolume" :header="$t('fixedBalanceDistribution.movelVolume')"  bodyClass="rightColumnContent" >
                        <template #body="element">
                            <span>{{utils.formatInteger(element.data.movedVolume)}}</span>
                        </template>
                    </Column>
                    <Column style="width: 160px" field="stockVolume15" :header="$t('fixedBalanceDistribution.stockVolume')" >
                        <template #body="element">
                            <span>{{utils.formatInteger(element.data.stockVolume)}}</span>
                        </template>
                    </Column>
                    <template #groupfooter="slotProps">
                        <td colspan="1" />
                        <td colspan="1" />
                        <td colspan="1" />
                        <td colspan="1" />
                        <td colspan="1" />
                        <td colspan="1" />
                        <td colspan="1" />
                        <td colspan="1" />
                        <td colspan="1" style="text-align:right; font-weight: bold;">{{ utils.formatInteger(calculateMovedQtyTotal('idScheduledOperation', slotProps.data.idScheduledOperation, equipmentOperations)) }}</td>
                        <td colspan="1" />
                        <td colspan="1" style="text-align:right; font-weight: bold;">{{ utils.formatInteger(calculateMovedVolumeTotal('idScheduledOperation', slotProps.data.idScheduledOperation, equipmentOperations)) }}</td>
                        <td colspan="1" />
                    </template>
                    <template #empty>
                        {{$t('noRecordsFound')}}
                    </template>
                </DataTable>
            </Panel>
        </div>
        <div class="col-12">
            <Dropdown v-model="selectedLotsSplitType" :options="splitTypes"  class="w-full md:w-14rem">
                <template #value="slotProps">
                    <div v-if="slotProps.value" class="flex align-items-center">
                        <div>{{ $t(slotProps.value) }}</div>
                    </div>
                    <span v-else>
                        {{ slotProps.placeholder }}
                    </span>
                </template>
                <template #option="slotProps">
                    <div class="flex align-items-center">
                        <div>{{ $t(slotProps.option) }}</div>
                    </div>
                </template>
            </Dropdown>
            <ResponsiveButton :label="$t('btn.calculate')" icon="pi pi-clone" class="mx-1" @click="calculate"/>   
        </div>
        <div class="col-12">
            <Panel :header="$t('fixedBalanceDistribution.shareResults')" :toggleable="true" v-model:collapsed="resultsDataCollapsed">
                <DataTable
                    groupRowsBy="lotCode" rowGroupMode="subheader"
                    :loading="resultsLoading"
                    :scrollable="true" scrollHeight="flex"
                    responsiveLayout="scroll" class="p-datatable-sm"
                    :reorderableColumns="true" ref="results" :value="results">
                    <!-- <Column selectionMode="multiple" style="width: 40px"></Column> -->
                    <Column style="width: 160px" field="tankCode" :header="$t('tankOperations.tank')" />
                    <Column style="width: 160px" field="operationDate" :header="$t('tankOperations.operationDate')">
                        <template #body="element">
                            {{element.data.operationDate != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(element.data.operationDate)) : null}}
                        </template>
                    </Column>
                    <Column style="width: 160px" field="fiscalCommunicationCode" :header="$t('fiscalNotification.notificationCode')" />
                    <Column style="width: 160px" field="productLevel" :header="$t('fixedBalanceDistribution.level')">
                        <template #body="element">
                            <span>{{utils.formatInteger(element.data.productLevel)}}</span>
                        </template>
                    </Column>
                    <Column style="width: 160px" field="temperature" :header="$t('fixedBalanceDistribution.temperature')" >
                        <template #body="element">
                            <span>{{utils.formatDecimal(element.data.temperature,2)}}</span>
                        </template>
                    </Column>
                    <Column style="width: 160px" field="density15" :header="$t('fixedBalanceDistribution.density')" >
                        <template #body="element">
                            <span>{{utils.formatDecimal(element.data.density15,5)}}</span>
                        </template>
                    </Column>
                    <Column style="width: 160px" field="waterLevel" :header="$t('fixedBalanceDistribution.waterLevel')" >
                        <template #body="element">
                            <span>{{utils.formatInteger(element.data.waterLevel)}}</span>
                        </template>
                    </Column>
                    <Column field="movedWeight" :header="$t('fixedBalanceDistribution.movedQty')" bodyClass="rightColumnContent">
                        <template #body="element">
                            <span>{{utils.formatInteger(element.data.movedWeight)}}</span>
                        </template>
                    </Column>
                    <Column style="width: 160px" field="stockWeight" :header="$t('fixedBalanceDistribution.stockQty')" >
                        <template #body="element">
                            <span>{{utils.formatInteger(element.data.stockWeight)}}</span>
                        </template>
                    </Column>
                    <Column  field="movedVolume" :header="$t('fixedBalanceDistribution.movelVolume')"  bodyClass="rightColumnContent" >
                        <template #body="element">
                            <span>{{utils.formatInteger(element.data.movedVolume)}}</span>
                        </template>
                    </Column>
                    <Column style="width: 160px" field="stockVolume15" :header="$t('fixedBalanceDistribution.stockVolume')" >
                        <template #body="element">
                            <span>{{utils.formatInteger(element.data.stockVolume)}}</span>
                        </template>
                    </Column>
                    <template #groupheader="slotProps">
                        <td colspan="1">{{slotProps.data.lotCode}}</td>
                    </template>
                    <template #groupfooter="slotProps">
                        <td colspan="1" />
                        <td colspan="1" />
                        <td colspan="1" />
                        <td colspan="1" />
                        <td colspan="1" />
                        <td colspan="1" />
                        <td colspan="1" />
                        <td colspan="1" style="text-align:right; font-weight: bold;">{{ utils.formatInteger(calculateMovedQtyTotal('lotCode', slotProps.data.lotCode, results)) }}</td>
                        <td colspan="1" />
                        <td colspan="1" style="text-align:right; font-weight: bold;">{{ utils.formatInteger(calculateMovedVolumeTotal('lotCode', slotProps.data.lotCode, results)) }}</td>
                        <td colspan="1" />
                    </template>
                    <template #empty>
                        {{$t('noRecordsFound')}}
                    </template>
                </DataTable>
            </Panel>
        </div>
        <div class="col-12">
            <ResponsiveButton :label="$t('btn.save')" icon="pi pi-save" class="mx-1" @click="saveSplitResults" :disabled="results == null || results.length == 0"/>   
        </div>
    </div>
  </main>
</template>